export const SPELL_SYSTEM_MANA = 'mana';
export const SPELL_SYSTEM_SLOTS = 'slots';

const VALID_SPELL_SYSTEMS = new Set([SPELL_SYSTEM_MANA, SPELL_SYSTEM_SLOTS]);
const MAX_SPELL_CAST_LEVEL_CAP = 9;

function clampSpellCastLevel(value) {
  if (value === null || value === undefined || value === '') return null;
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return null;
  return Math.max(0, Math.min(MAX_SPELL_CAST_LEVEL_CAP, Math.trunc(numericValue)));
}

export function getLegacySpellSlotsMaxCastLevel(spellSlots = {}) {
  const levels = Object.keys(spellSlots || {})
    .map(Number)
    .filter((level) => Number.isFinite(level) && (spellSlots?.[level] || 0) > 0);
  return levels.length > 0 ? Math.max(...levels) : null;
}

export function normalizeScalarSpellProgression(progression = {}, fallbackMaxCastLevel = null) {
  const directMaxCastLevel = clampSpellCastLevel(progression?.maxCastLevel);
  if (directMaxCastLevel !== null) {
    return { maxCastLevel: directMaxCastLevel };
  }

  const fallback = clampSpellCastLevel(fallbackMaxCastLevel);
  if (fallback !== null) {
    return { maxCastLevel: fallback };
  }

  return null;
}

export function getScalarSpellProgressionMaxCastLevel(settings = {}, fallbackMaxCastLevel = null) {
  return normalizeScalarSpellProgression(settings?.scalarSpellProgression, fallbackMaxCastLevel)?.maxCastLevel ?? null;
}

export function getCanonicalSpellSystem(settings = {}) {
  if (VALID_SPELL_SYSTEMS.has(settings?.spellSystem)) {
    return settings.spellSystem;
  }
  if (settings?.manaEnabled === false) {
    return SPELL_SYSTEM_SLOTS;
  }
  return SPELL_SYSTEM_MANA;
}

export function isManaSpellSystem(settings = {}) {
  return getCanonicalSpellSystem(settings) === SPELL_SYSTEM_MANA;
}

export function syncSpellSettings(settings = {}, patch = {}) {
  const merged = { ...(settings || {}), ...(patch || {}) };
  const spellSystem = VALID_SPELL_SYSTEMS.has(patch?.spellSystem)
    ? patch.spellSystem
    : (typeof patch?.manaEnabled === 'boolean'
        ? (patch.manaEnabled ? SPELL_SYSTEM_MANA : SPELL_SYSTEM_SLOTS)
        : getCanonicalSpellSystem(merged));
  const normalizedScalarSpellProgression = normalizeScalarSpellProgression(merged.scalarSpellProgression);
  const { scalarSpellProgression: _ignoredScalarSpellProgression, ...restMerged } = merged;

  return {
    ...restMerged,
    spellSystem,
    manaEnabled: spellSystem === SPELL_SYSTEM_MANA,
    ...(normalizedScalarSpellProgression ? { scalarSpellProgression: normalizedScalarSpellProgression } : {}),
  };
}
